// Third party
import {
  DiamondCollectionListingsListAllDocument,
  DiamondCollectionListingsListAllQuery,
  DiamondCollectionListingsListAllQueryVariables,
} from '@gql';

// Utils
import { createApolloClient } from '../apollo-node-client';

type Options = {
  variables?: DiamondCollectionListingsListAllQueryVariables;
};

export const imperativeDiamondCollectionListingsQuery = async (
  options: Options,
  accessToken?: string
) => {
  let apolloClient = createApolloClient();

  if (accessToken) {
    apolloClient = createApolloClient(accessToken);
  }

  const response =
    await apolloClient.query<DiamondCollectionListingsListAllQuery>({
      ...{ query: DiamondCollectionListingsListAllDocument },
      ...options,
    });

  return { ...response, ...{ apolloClient } };
};

export type DiamondCollectionListingPartial =
  DiamondCollectionListingsListAllQuery['listingsListAllActive']['entries'][0];
